export function toggleClass (element, className) {
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += ` ${className}`
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export function removeClass (element, className) {
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) { return }
  classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  element.className = classString
}
